import * as React from 'react';
import { useLanguage } from '../../locale';
import { useSearchFilters } from './useSearchFilters';
export var useNoCookFilterSectionFacade = function () {
    var t = useLanguage()[0];
    var _a = React.useState(), noCookFilterOption = _a[0], setNoCookFilterOption = _a[1];
    var _b = useSearchFilters(), setIsNoCookToFilter = _b.setIsNoCookToFilter, selectedIsNoCookFilter = _b.selectedIsNoCookFilter;
    var options = React.useMemo(function () {
        return [
            {
                type: 'default',
                label: "".concat(t('yes')),
                value: true,
            },
            {
                type: 'default',
                label: "".concat(t('filters.indifferent')),
                value: false,
            },
        ];
    }, [t]);
    React.useEffect(function () {
        if (selectedIsNoCookFilter === null) {
            setNoCookFilterOption(null);
        }
        else {
            var optionToSet = options.find(function (o) { return o.value === selectedIsNoCookFilter; });
            setNoCookFilterOption(optionToSet !== null && optionToSet !== void 0 ? optionToSet : null);
        }
    }, [options, selectedIsNoCookFilter]);
    var reset = React.useCallback(function () {
        setNoCookFilterOption(null);
        setIsNoCookToFilter(null);
    }, [setIsNoCookToFilter]);
    var applyFilter = React.useCallback(function () {
        var _a;
        setIsNoCookToFilter((_a = noCookFilterOption === null || noCookFilterOption === void 0 ? void 0 : noCookFilterOption.value) !== null && _a !== void 0 ? _a : null);
    }, [noCookFilterOption, setIsNoCookToFilter]);
    return {
        options: options,
        noCookFilterOption: noCookFilterOption,
        setNoCookFilterOption: setNoCookFilterOption,
        reset: reset,
        applyFilter: applyFilter,
    };
};
